import './App.css';
import { useEffect, useRef, useState } from 'react'
import fetchData  from './sendmssgtoopenai';

function App() {
  const mssgEnd = useRef(null)
  const [input, setInput] = useState("")
  const [messages, setMessages] = useState([])

  useEffect(() => {
    mssgEnd.current.scrollIntoView()
  }, [messages])

  const handleSend = async () => {
    const text = input
    setInput("")
    setMessages([...messages, {text, isBot:false}])
    const res = await fetchData(input)

    setMessages([
      ...messages,
      {text, isBot:false},
      {text: res, isBot: true}
    ])
  }

  async function handleEnter(e){
    if(e.key === 'Enter')
      await handleSend()
  }
  async function handleQuery(e){
    const text = e.target.value
    setMessages([...messages, {text, isBot:false}])
    const res = await fetchData(text)

    setMessages([
      ...messages,
      {text, isBot:false},
      {text: res, isBot: true}
    ])
  }

  
  return (
    <div className="App">
      <div className="sidebar">
        <div className="upperSide">
          <div className="upperSideTop"><img src="chatgpt.svg" alt="" className="logo" /><span className="brand">ChatGPT-4o mini</span></div>
          <button className="midButton" onClick={() => window.location.reload()}><img src="add-30.png" alt="new cht" className="plusSign" />New Chat</button>
          <div className="upperSideBottom">
            <button className="query" onClick={handleQuery} value={'What is programming?'} ><img src="message.svg" alt="" />What is programming?</button>
            <button className="query" onClick={handleQuery} value={'How to use an API?'} ><img src="message.svg" alt="" />How to use an API?</button>
          </div>
        </div>
        <div className="lowerSide">
          <div className="listItems"><img src="home.svg" alt="" className="listIcons" /><a href='https://www.ibrahimyousif.com'>ibrahim yousif</a></div>
          <div className="listItems"><img src="bookmark.svg" alt="" className="listIcons" />Saved (comming soon)</div>
          <div className="listItems"><img src="rocket.svg" alt="" className="listIcons" />Upgrade to pro (comming soon)</div>
        </div>
      </div>
      <div className="main">
        <div className="chats">
          {messages.map((message, i) => 
            <div key={i} className={message.isBot?"chat bot fade-in-from-top":"chat"}>
              <img className="chatImage" src={message.isBot?"chatgptLogo.svg":"user-icon.png"} alt="" /><p className="txt"> {message.text }</p>   
            </div>     
          )} 
          <div ref={mssgEnd}/>
        </div>
        <div className="chatFooter">
          <div className="inp">
            <input type="text" placeholder="Ask me anything..." value={input} onKeyDown={handleEnter} onChange={(e) => {setInput(e.target.value)}} /> <button onClick={handleSend} className="send"><img src="send.svg" alt="send" /></button>
          </div>
          <p>ChatGPT may produce inaccurate information about people, places or facts. knowledgde limited up to year 2023</p>
        </div>
      </div>
    </div>
  );
}

export default App;
